import { ForumMinusOutlineIcon } from './ForumMinusOutlineIcon';

/**
 * author: nlsve
 * id B62A5E78-9D61-47C7-97DA-B1DFFDACFACC
 * name forum-minus-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum-minus-outline.svg
 * tags
 */
export const DialogueMinusOutlineIcon = ForumMinusOutlineIcon;
export default DialogueMinusOutlineIcon